var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AIButton } from '@web/components/layout/AIInsights/AIButton';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import PaginatedTable from '@web/components/layout/PaginatedTable/PaginatedTable';
import EventIcon from '@web/components/Settings/Events/EventIcon';
import EventsTableTitleEvent from '@web/components/Settings/Events/EventsTable/EventsTableTitleEvent';
import Badge from '@web/components/ui/Badge/Badge';
import UserAvatar from '@web/components/UserAvatar';
import { ACTIVITY_COLORS, EVENTS_LOG_PAGE_SIZE } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { getLimitOffset, isAiButtonDisabled } from '@web/utility';
import { formatEventsLogEventTitle } from '@web/utility/eventsLogUtils';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
var formatEventsLogDateTime = function (date) {
    var parsedDate = new Date(date);
    return format(parsedDate, 'dd MMM HH:mm:ss');
};
function EventsTable() {
    var _this = this;
    var _a;
    var t = useTranslation().t;
    var _b = useFilters(), dateFrom = _b.dateFrom, dateTo = _b.dateTo, app = _b.app, page = _b.page, activityLabel = _b.activityLabel, user = _b.user, orgUnit = _b.orgUnit;
    var _c = getLimitOffset(page, EVENTS_LOG_PAGE_SIZE), limit = _c.limit, offset = _c.offset;
    var _d = trpc.events.useQuery({
        limit: limit,
        offset: offset,
        dateFrom: dateFrom,
        dateTo: dateTo,
        applicationName: app,
        activityLabelId: activityLabel,
        userId: user,
        orgUnitId: orgUnit
    }), data = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    var columns = [
        {
            title: t('eventsLog.dateTime'),
            isVisible: true,
            className: 'w-1/5 sm:px-3'
        },
        {
            title: t('eventsLog.actor'),
            isVisible: true,
            className: 'w-1/5 sm:px-3'
        },
        {
            title: t('eventsLog.app'),
            isVisible: true,
            className: 'w-1/5 sm:px-3'
        },
        {
            title: t('eventsLog.event'),
            isVisible: true,
            className: 'sm:px-3 w-2/5'
        }
    ];
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var tableData = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map(function (event) {
        return [
            {
                id: "".concat(event.id, "-date"),
                render: function () { return (_jsx("span", __assign({ className: "text-gray-500" }, { children: formatEventsLogDateTime(event.date) }))); }
            },
            {
                id: "".concat(event.id, "-actor"),
                render: function () { return (_jsxs("div", __assign({ className: 'flex flex-col justify-center md:flex-row md:justify-start items-start md:items-center' }, { children: [_jsx("div", __assign({ className: "flex-shrink-0 h-10 w-10 sm:mb-2 md:mb-0" }, { children: _jsx(UserAvatar, { size: 'large', user: event.user }) })), _jsxs("div", __assign({ className: "md:ml-4 text-left" }, { children: [_jsx("div", __assign({ className: "flex text-sm font-medium text-gray-900" }, { children: _jsx("span", __assign({ className: "mr-1.5 md:mr-3  truncate w-36" }, { children: event.user.name })) })), _jsx("div", __assign({ className: "text-sm text-gray-5 \n          00" }, { children: event.user.email }))] }))] }))); }
            },
            {
                id: "".concat(event.id, "-labels"),
                render: function () { return (_jsx(Badge, __assign({ className: "bg-".concat(ACTIVITY_COLORS[event.applicationName].color) }, { children: event.applicationName }))); }
            },
            {
                id: "".concat(event.id, "-event"),
                render: function () { return (_jsxs("div", __assign({ className: "flex items-start gap-2 min-w-0" }, { children: [_jsx("div", __assign({ className: "h-5 w-5 text-gray-500 flex-shrink-0" }, { children: _jsx(EventIcon, { action: event.action }) })), _jsx(EventsTableTitleEvent, { event: __assign(__assign({}, event), { date: new Date(event.date) }) })] }))); }
            }
        ];
    });
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "mb-3 flex flex-wrap items-center justify-end gap-2 px-2 sm:px-4" }, { children: [_jsx(ExportMenu, { fileName: t('insights.tables.eventsTable'), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                return [2 /*return*/, ((_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : []).map(function (event) {
                                        var _a;
                                        var _b, _c, _d, _e, _f;
                                        return (_a = {},
                                            _a[t('eventsLog.dateTime')] = formatEventsLogDateTime(event.date),
                                            _a[t('eventsLog.actor')] = ((_b = event.user) === null || _b === void 0 ? void 0 : _b.name) && ((_c = event.user) === null || _c === void 0 ? void 0 : _c.email)
                                                ? "".concat(event.user.name, " (").concat(event.user.email, ")")
                                                : ((_e = (_d = event.user) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : (_f = event.user) === null || _f === void 0 ? void 0 : _f.email),
                                            _a[t('eventsLog.app')] = event.applicationName,
                                            _a[t('eventsLog.event')] = formatEventsLogEventTitle(event, t),
                                            _a);
                                    })];
                            });
                        }); }, disabled: isAiButtonDisabled(data) }), _jsx(AIButton, { insightsData: data, insightType: InsightTypeEnum.eventsTable, refetch: refetch })] })), _jsx(PaginatedTable, { columns: columns, data: tableData !== null && tableData !== void 0 ? tableData : [], total: data === null || data === void 0 ? void 0 : data.total, typeResultText: t('eventsLog.events'), pageSize: EVENTS_LOG_PAGE_SIZE })] }));
}
export default EventsTable;
